import React from "react";
import "./TakeALookButton.scss";
import spyglass from "../../../../assets/svg/vergrootglas.svg";
import { Button } from "../../../Button/Button";

interface IProps {
    onClick: () => void;
    visible: boolean;
}

export function TakeALookButton(props: IProps) {
    const classes = ['take-a-look-button-wrapper', ...(props.visible ? ['visible'] : [])];
    return (
        <Button variant={'yellow'} className={classes.join(' ')} onClick={props.onClick}>
            Take a look <img src={spyglass} alt={''} />
        </Button>
    )
}
